const CORS_PROXY_SERVER = "cors-proxy-dev.reticulum.io";
// window.location
class ProxyService {
    constructor() {
        this.nonCorsProxyDomains = [window.location.hostname, "assets-prod.reticulum.io"];
    }
    proxiedUrlFor(url) {
        if (!(url.startsWith("http:") || url.startsWith("https:")))
            return url;
        if (!this.shouldCorsProxy(url)) {
            return url;
        }
        return `https://${CORS_PROXY_SERVER}/${url}`;
    }
    shouldCorsProxy(url) {
        // Skip known domains that do not require CORS proxying.
        try {
            const parsedUrl = new URL(url);
            if (this.nonCorsProxyDomains.find((domain) => parsedUrl.hostname.endsWith(domain)))
                return false;
        }
        catch (e) {
            // Ignore
        }
        return true;
    }
}
export const proxyService = new ProxyService();
